import SignInLogo from '../../../assets/svgComponents/SignInLogo'
import { Box, Typography } from '@mui/material'
import { TextsContainer } from '../../../pages/AuthPages/ForgotPasswordPage/ForgotPasswordPage.styled'
import { EnvBasedStyles, getMode } from '../../../utils/env'
import { LogoTag } from './LogoTag'
import { isBakerModule } from '../../../utils/helpers/isBakerModule'

export const AuthLogo = () => {
  const envBasedStyling = EnvBasedStyles[getMode()]

  return (
    <Box display="flex" gap="10px" justifyContent="center">
      <SignInLogo />
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        position="relative"
      >
        <Typography
          component="h1"
          lineHeight="20px"
          fontWeight="800"
          color="#C93C41"
          fontSize="26px"
        >
          EQUINOM
        </Typography>
        <TextsContainer>
          <Typography>Manna</Typography>
          {isBakerModule ? (
            <Typography fontWeight="700">Bakery</Typography>
          ) : (
            <Typography fontWeight="700">Wheat</Typography>
          )}
        </TextsContainer>
        <LogoTag
          label={envBasedStyling.label}
          color={envBasedStyling.color}
          top={-20}
          right={1}
        />
      </Box>
    </Box>
  )
}
